import styled, { css } from 'styled-components';
import { combineValues, globalTheme } from '@clds/component-theme';
import { ReactSliderProps } from '../ReactSlider';
import { sliderTheme } from '../sliderTheme';

const Track = styled.div<ReactSliderProps & { selected?: boolean }>`
  height: ${sliderTheme.normal.height};
  position: relative;

  &::after {
    content: '';
    height: ${sliderTheme.normal.track.height};
    width: 100%;
    ${({ selected }) =>
      selected &&
      css`
        background-color: ${combineValues(
          globalTheme.palette.primary,
          globalTheme.palette.secondary,
          // TODO: Fix types related to migration to DS
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          (sliderColor, disabledColor, { disabled }: ReactSliderProps) => (disabled ? disabledColor : sliderColor)
        )};
      `};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
`;

export default Track;
